/* eslint-disable no-useless-escape */
/*
 * This file contains helper functions that are registered as Handlebars helpers
 * but also directly used as helpers in our code. This was done as part of
 * ADR #103: https://docs.google.com/document/d/1ubVIYm3tPxH3yE8NSiLwJLVqm-ztk8_zHfVJczbr_j4/edit#
 */

const Autolink = (function () {
    // from http://daringfireball.net/2010/07/improved_regex_for_matching_urls
    const regex =
        /\b(?:(?:https?:\/\/|www\d{0,3}[.]|[a-z0-9.\-]+[.][a-z]{2,4}\/)(?:[^\s()<>&]+|&amp;|\((?:[^\s()<>]|(?:\([^\s()<>]+\)))*\))+(?:\((?:[^\s()<>]|(?:\([^\s()<>]+\)))*\)|[^\s`!()\[\]{};:'".,<>?«»“”‘’&]))/gi;

    return {
        autolink: function (text, nofollow) {
            return text.replace(regex, function (url) {
                if (!/^https?:\/\//.test(url)) {
                    url = "http://" + url;
                }

                const nofollowAttr = nofollow ? 'rel="nofollow"' : "";

                return (
                    "<a " + nofollowAttr + ' href="' + url + '">' + url + "</a>"
                );
            });
        },
    };
})();

const formatTimestamp_ = function (timestamp, minutes, seconds) {
    const numSeconds = 60 * parseInt(minutes, 10) + parseInt(seconds, 10);
    return (
        "<span class='youTube' data-seconds='" +
        numSeconds +
        "'>" +
        timestamp +
        "</span>"
    );
};

const timestampRegex = /(\d{1,3}):([0-5]\d)/g;

// Copied from third_party/javascript-khansrc/handlebars/handlebars-v4.0.12.js
// to avoid this file having a circular dependency on handlebars-v4.0.12.js
const escapeExpression = function (string) {
    const badChars = /[&<>"'`=]/g;
    const possible = /[&<>"'`=]/;

    const escape = {
        "&": "&amp;",
        "<": "&lt;",
        ">": "&gt;",
        '"': "&quot;",
        "'": "&#x27;",
        "`": "&#x60;",
        "=": "&#x3D;",
    };

    const escapeChar = function (chr) {
        return escape[chr];
    };

    if (typeof string !== "string") {
        // don't escape SafeStrings, since they're already safe
        if (string && string.toHTML) {
            return string.toHTML();
        }
        if (string == null) {
            return "";
        }
        if (!string) {
            return string + "";
        }

        // Force a string conversion as this will be done by the append regardless and
        // the regex test will do this transparently behind the scenes, causing issues if
        // an object's to string has escaped characters in it.
        string = "" + string;
    }

    if (!possible.test(string)) {
        return string;
    }
    return string.replace(badChars, escapeChar);
};

/* Format the content using our own flavor of markdown used in discussions. use
 * nofollow to add rel=nofollow to any links included in the content (to avoid
 * giving them link juice).
 *
 * Example:
 *
 *     > formatContent("My *spammy* blog: http://spam.com")
 *     'My <b>spammy</b> blog: <a  href="http://spam.com">http://spam.com</a>'
 *
 *     > formatContent("My *spammy* blog: http://spam.com", true)
 *     'My <b>spammy</b> blog: <a rel="nofollow"
 *     href="http://spam.com">http://spam.com</a>'
 */
export const formatContent = function (content, nofollow) {
    // Escape user generated content
    content = escapeExpression(content);

    // Format video timestamps
    content = content.replace(timestampRegex, formatTimestamp_);

    const newlineRegex = /[\n]/g;
    content = content.replace(newlineRegex, "<br>");

    // Replace Markdown with HTML tags. (Keep in sync with edit function in
    // discussion.js.)
    content = content.replace(
        /(\W|^)_(\S.*?\S)_(\W|$)/g,
        function (m, a, b, c) {
            return a + "<em>" + b + "</em>" + c;
        },
    );

    content = content.replace(
        /(\W|^)\*(\b.*?\b)\*(\W|$)/g,
        function (m, a, b, c) {
            return a + "<b>" + b + "</b>" + c;
        },
    );

    // Difference between <code> and <pre><code>: http://stackoverflow.com/q/4611591/
    content = content.replace(
        /&#x60;&#x60;&#x60;(.*?)&#x60;&#x60;&#x60;/gm,
        function (m, n) {
            // Remove leading line breaks.
            n = n.replace(/^\s*(<br>)+/, "");
            // Remove trailing line breaks.
            n = n.replace(/(<br>)+\s*$/, "");
            return "<pre><code>" + n + "</code></pre>";
        },
    );

    content = content.replace(/&#x60;(.*?)&#x60;/g, function (m, n) {
        return "<code>" + n + "</code>";
    });
    content = Autolink.autolink(content, nofollow);

    // Use SafeString because we already escaped the user generated
    // content and then added our own safe html
    return content;
};

/**
 * A helper to strip the leading protocol from a URI, if any is found.
 */
export const stripProtocol = function (url) {
    if (!url) {
        return url;
    }
    if (url.indexOf("http://") === 0) {
        return url.substring(5);
    }
    if (url.indexOf("https://") === 0) {
        return url.substring(6);
    }
    return url;
};
